import { createContext, useContext, useMemo } from "react";

const NOOP = () => {};

const DEFAULT_CAMPAIGN_AGENT_PANEL_CONTEXT = {
  isEnabled: false,
  onFocusPublishAction: NOOP,
  onChangePendingChangesCount: NOOP,
};

const CampaignAgentPanelContext = createContext(null);

export const CampaignAgentPanelProvider = ({ value, children }) => {
  const contextValue = useMemo(
    () => ({
      isEnabled: true,
      onFocusPublishAction: value?.onFocusPublishAction || NOOP,
      onChangePendingChangesCount: value?.onChangePendingChangesCount || NOOP,
    }),
    [value]
  );

  return (
    <CampaignAgentPanelContext.Provider value={contextValue}>
      {children}
    </CampaignAgentPanelContext.Provider>
  );
};

// eslint-disable-next-line
export const useCampaignAgentPanel = () =>
  useContext(CampaignAgentPanelContext) ?? DEFAULT_CAMPAIGN_AGENT_PANEL_CONTEXT;
